import React from 'react';
import { Animated, TouchableOpacity, ScrollView, View, FlatList } from 'react-native';

import { VFText } from '@vfgroup-oneplatform/foundation/Components';
import { Colors, LightThemeColors, withTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';
import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import { isNil as _isNil } from 'lodash';
import PropTypes from 'prop-types';

import BillingTestKeys from '../../../../Utils/BillingTestKeys.js';
import styles from '../BarChart.Styles';

function BarChartDetails({
  billsPerMonth,
  animatedStyle,
  containerStyle,
  onBarDetailsPress,
  theme,
  showTimePeriod,
  billTypes,
  isYearVisible
}) {
  return (
    <View
      style={[
        styles.seeBarBillContainer(billsPerMonth?.data?.length),
        containerStyle,
        { zIndex: 300, marginLeft: 20 },
        isYearVisible && styles.yearMargin
      ]}
      activeOpacity={1}
    >
      <ScrollView
        style={{ flexGrow: 1 }}
        nestedScrollEnabled={true}
        contentContainerStyle={{ flexGrow: 1 }}
        bounces={false}
      >
        <View onStartShouldSetResponder={() => true}>
          {billsPerMonth?.data && billsPerMonth?.data?.map((billDetails, index) => {
            const isAvailableBill = !_isNil(billDetails.value);
            const isNegativeBill = billDetails.value < 0

            let customColor = (billTypes && billTypes.length > 0
              && billTypes.find(el => el?.id === billDetails?.billType)) ?
              billTypes.find(el => el?.id === billDetails?.billType).color : Colors.vfRed

            return (
              <Animated.View
                key={index}
                style={[
                  animatedStyle,
                  isNegativeBill ? styles.seeBarBillBottom : undefined,
                  { paddingBottom: 15, },
                ]}
              >
                {showTimePeriod && (
                  <VFText
                    style={[styles.seeBarBillTitle(theme), billDetails.timePeriodStyle]}
                    i18nKey={billDetails.timePeriod}
                    testKey={BillingTestKeys.barChartDetailsTimePeriodText}
                  />
                )}
                <VFText
                  accessibilityLabel="BillAmount"
                  style={styles.seeBarBillSubTitle(theme, isAvailableBill)}
                  testKey={BillingTestKeys.barChartDetailsBillAmountText}
                  i18nKey={
                    !isAvailableBill
                      ? 'billing_chart_unavailable_bill'
                      : billDetails.customBillValueText
                        ? billDetails.customBillValueText
                        : billDetails.isCurrencyFirst
                          ? billDetails.currency + ' ' + billDetails.value.toLocaleString()
                          : billDetails.value.toLocaleString() + ' ' + billDetails.currency
                  }
                />
                {isAvailableBill && (
                  <TouchableOpacity
                    onPress={() => onBarDetailsPress(billDetails)}
                    activeOpacity={1}
                    testID={BillingTestKeys.barChartDetailsBtn}
                  >
                    <VFText
                      style={[
                        styles.seeBarBillButton(theme),
                        isNegativeBill ? styles.seeBarBillButtonNegativeBill : undefined,
                        { color: customColor }
                      ]}
                      i18nKey="billing_chart_see_bill"
                      testID={BillingTestKeys.barChartDetailsSeeBillText}
                    />
                  </TouchableOpacity>
                )}
              </Animated.View>
            )
          })}
        </View>
      </ScrollView>
    </View>
  );
}

BarChartDetails.defaultProps = {
  billDetails: {},
  animatedStyle: {},
  onBarDetailsPress: () => { },
  theme: LightThemeColors,
  showTimePeriod: true,
};

BarChartDetails.propTypes = {
  billDetails: PropTypes.object,
  animatedStyle: PropTypes.object,
  onBarDetailsPress: PropTypes.func,
  theme: PropTypes.object,
  showTimePeriod: PropTypes.bool,
  containerStyle: ViewPropTypes.style,
  billTypes: PropTypes.array,
  isYearVisible: PropTypes.bool
};

export default withTheme(BarChartDetails);
